import { ArrowIcon } from './components/ArrowIcon';

import type { SvgIconProps } from '@mui/material';
import type { FC } from 'react';

export const ARROW_DROPDOWN_ICON_TEST_ID = 'arrow-dropdown-icon';

interface ArrowDropdownIconProps extends SvgIconProps {
  opened?: boolean;
}

export const ArrowDropdownIcon: FC<ArrowDropdownIconProps> = ({
  opened = false,
  sx,
  ...props
}) => (
  <ArrowIcon
    data-testid={ARROW_DROPDOWN_ICON_TEST_ID}
    fontSize="medium"
    color="action"
    {...props}
    sx={{ transform: `rotateZ(${opened ? '180deg' : '0deg'})`, ...sx }}
  />
);
